import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { MatTableModule } from "@angular/material/table";
import { TranslocoModule } from "@jsverse/transloco";

import { DevicesAllComponent } from "./components/devices-all/devices-all";
import { DevicesRoutingModule } from "./devices-routing.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";
import { LorenDateModule } from "../../shared/pipes/loren-date/loren-date.module";
import { BatteryLevelComponent } from "../../shared/modules/loren-battery-level/components/battery-level/battery-level";

@NgModule({
  declarations: [DevicesAllComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    TranslocoModule,
    DevicesRoutingModule,
    LorenPageContentComponent,
    LorenDateModule,
    BatteryLevelComponent,
  ],
})
export class DevicesModule {}
